module.exports = __webpack_public_path__ + "static/media/ConsistencyChampion.3e844ce2.svg";